import InsurranceTab from './InsuranceLayout/InsurranceTab';
const Patientinsurance = (props) => {
    console.log(props, 'insuranceTab in Patientinsurance');
    
    return (
        <div>
            <InsurranceTab Reload={props} ActivePatientID={props.ActivePatientID}/>
        </div>
    )
}
export default Patientinsurance;